import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/app/providers/AuthProvider';
import { HubId, AppId, PermissionsHelper } from '@/types/permissions';
import { HubMaintenanceGate } from '@/components/maintenance/HubMaintenanceGate';

interface RequireAppAccessProps {
  hubId: HubId;
  appId: AppId;
  children: React.ReactElement;
}

/**
 * @deprecated Usare RequireScope con scope="access:app:{appId}:{hubId}" invece
 * 
 * Componente di protezione route per accesso App
 * Verifica se l'utente può accedere a un'app specifica dentro un hub
 * 
 * Questo componente è deprecato in favore di RequireScope che supporta
 * un sistema di permessi più granulare basato su scopes.
 * 
 * Migrazione:
 * <RequireAppAccess hubId="business" appId="dashboard"> → <RequireScope scope="access:app:dashboard:business">
 */
const RequireAppAccess: React.FC<RequireAppAccessProps> = ({ hubId, appId, children }) => {
  const { user, loading, canAccessApp } = useAuth();

  // Mostra loader durante la verifica
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white to-zinc-50 dark:from-zinc-900 dark:to-zinc-800">
        <div className="w-12 h-12 border-3 border-zinc-200 dark:border-zinc-700 border-t-zinc-600 dark:border-t-zinc-400 rounded-full animate-spin"></div>
      </div>
    );
  }

  // Utente non autenticato - redirect al login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Verifica permessi App usando canAccessApp dal context (include fix temporanei)
  if (!canAccessApp(hubId, appId)) {
    return <Navigate to="/forbidden" replace />;
  }

  // Utente ha accesso all'app - mostra contenuto
  return <HubMaintenanceGate hubId={hubId}>{children}</HubMaintenanceGate>;
};

export default RequireAppAccess;
